import i18n from '@/config/i18n'

export const supportedLangs = ['en', 'ko', 'zh-CN', 'zh-TW', 'jp'] as const
export type Lang = typeof supportedLangs[number]

export const isSupportedLang = (value: string | null | undefined): value is Lang => {
  return !!value && (supportedLangs as readonly string[]).includes(value)
}

export const setLangCookie = (lang: Lang) => {
  const expires = new Date()
  expires.setFullYear(expires.getFullYear() + 1)
  document.cookie = `lang=${lang}; path=/; expires=${expires.toUTCString()}; Secure; SameSite=Strict`
}

export const changeLanguageAndPersist = (lang: Lang) => {
  setLangCookie(lang)
  i18n.changeLanguage(lang)
}


